import React, { FC, HTMLProps, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import cn from "classnames";
import stl from "./index.module.scss";
// import image from "../../assets/icons/preloader_xmas.gif";
import image from "../../assets/icons/preloader.gif";

interface Props extends HTMLProps<HTMLDivElement> {
  fill?: boolean;
  blockWindow?: boolean;
}

const Progress: FC<Props> = ({
  fill,
  blockWindow,
  className,
  children,
  ...props
}) => {
  const [container] = useState<HTMLDivElement>(() => {
    const el = document.createElement("div");
    el.className = stl.blockWindowContainer;
    el.setAttribute("role", "modal");
    return el;
  });

  const content = (
    <div
      {...props}
      className={cn(stl.block, className, {
        [stl.fill]: fill,
      })}
    >
      <img className={stl.image} src={image} alt="" />
      {children ? <div className={stl.content}>{children}</div> : null}
    </div>
  );

  useEffect(() => {
    if (blockWindow) {
      document.body.appendChild(container);
      return () => {
        document.body.removeChild(container);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockWindow]);

  if (blockWindow) {
    return createPortal(content, container);
  }

  return content;
};

export default Progress;
